import { useMemo } from 'react'
import { useSweepsKycModal } from './useSweepsKycModal'
import { usePurchaseBlockedModal } from './usePurchaseBlockedModal'

export const useModalsState = () => {
  const sweepsKycModalState = useSweepsKycModal()
  const purchaseBlockedModalState = usePurchaseBlockedModal()

  const modalsState = useMemo(
    () => ({
      ...sweepsKycModalState,
      ...purchaseBlockedModalState
    }),
    [sweepsKycModalState, purchaseBlockedModalState]
  )

  return { modalsState }
}
